export default __webpack_public_path__ + "static/media/Distributor-40-line.17e72a3d.jpg";